export { ApiInput, ApiInputDS } from './ApiInput';
export { BaseButton, BaseButtonDS } from './BaseButton';
export { BaseCard } from './BaseCard';
export { BaseCardSeparator } from './BaseCardSeparator';
export { BaseCheckbox, BaseCheckboxDS } from './BaseCheckbox';
export { BaseIcon, BaseIconDS } from './BaseIcon';
export { BaseIconMatrix, BBaseIconMatrixDS } from './BaseIconMatrix';
export { BaseInput, BaseInputDS } from './BaseInput';
export { BaseModal, BaseModalDS } from './BaseModal';
export { BaseNotificationCard, BaseNotificationCardDS } from './BaseNotificationCard';
export { BaseRadioButton, BaseRadioButtonDS } from './BaseRadioButton';
export { ButtonLink, ButtonLinkDS } from './ButtonLink';
export { ChevronSelect, ChevronSelectDS } from './ChevronSelect';
export { ComboInput, ComboInputDS } from './ComboInput';
export { DateInput, DateInputDS } from './DateInput';
export { EmailInput, EmailInputDS } from './EmailInput';
export { GenderInput, GenderInputDS } from './GenderInput';
export {
  AccountOpeningDateRules,
  AddressBisRules,
  AddressCityRules,
  AddressRules,
  BirthCityRules,
  BirthNameRules,
  ChildCareExpensesRules,
  CreditsProjectMensualitesRules,
  CreditsProjectRestantRules,
  CreditsProjectRules,
  CtlmLoanAmountRules,
  EmailRules,
  EmploymentPhoneRules,
  ExpenseFoodPensionRules,
  FamilyAllowanceRules,
  FirstNameRules,
  HolderSalaryRules,
  HomePhoneRules,
  LastNameRules,
  logementDateRules,
  MobilePhoneRules,
  OthersLoanAmountRules,
  PensionIncomeRules,
  PropertyIncomeRules,
  RentAmountRules,
  ZipCodeRules,
} from './InputRules';
export { NumericInput, NumericInputDS } from './NumericInput';
export { NumericStepper, NumericStepperDS } from './NumericStepper';
export { PhoneInput, PhoneInputDS } from './PhoneInput';
export { RadioButtonCard, RadioButtonCardDS } from './RadioButtonCard';
export { SelectedButton, SelectedButtonDS } from './SelectedButton';
export { SelectedButton2, SelectedButtonDS2 } from './SelectedButton2';
export type Replacement = {
  regexp: unknown;
  replacement: string;
};

export type CustomValidity = {
  regexp: unknown;
  errorMessage: string;
};

export enum ApiStatus {
  OK = 'ok',
  KO = 'ko',
  LOADING = 'loading',
}
